export const applicationsOptions = [
    { label: 'Community', value: 'community' },
    { label: 'Residence', value: 'residence' },
    { label: 'Property management', value: 'property_management' },
];
